import noteTypeMapping
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/AllNotes/AllNotes/noteTypeMapping';

export function groupResourcesByType(resources) {
  const groups = resources.reduce((accumulator, currentValue) => {
    const noteType = noteTypeMapping.find(type => type.id === currentValue.attr('noteType'));
    if (noteType === undefined) {
      return accumulator;
    }

    if (accumulator[noteType.id] === undefined) {
      accumulator[noteType.id] = Object.assign({}, noteType);
      accumulator[noteType.id].notes = [currentValue];
    } else {
      accumulator[noteType.id].notes.push(currentValue);
    }
    return accumulator;
  }, {});

  // sort by ordinal
  const groupsArray = Object.values(groups);
  groupsArray.sort((a, b) => a.ordinal - b.ordinal);

  return groupsArray;
}
